/**
 * Bonus Counter Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    const BaseReplacerView = require('common/base.replacer.view');
    const BonusCollection = require('replacers/bonus-counter/bonus-counter.collection');
    const BalanceModel = require('replacers/bonus-counter/bonus-counter.balance.model');
    const core = require('core');
    const config = require('config');
    const checkCounterClass = require('../../common/swiss-theme/checkConterClass/checkCounterClass');
    const $ = require('j');

    require('widgets/accordion.widget');

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        subscribe: function() {
            this.listenTo(core, 'notification-bonusCounter:updated', this._loadBonuses);
            this.listenTo(core, 'notification-bonusMultiviewCounter:updated', this._loadBonuses);
            this.listenTo(core, 'notification-bonus:info', this._showBonusAfterCanceling);
        },

        initialize: function(options) {
            this.bonuses = new BonusCollection();
            this.balanceModel = new BalanceModel();
            this.isMobileHeader = options.params.length && options.params[0] === 'mobileHeader';
        },

        render: function() {
            this._loadBonuses();

            return this;
        },

        _loadBonuses: function() {
            $.when(this.bonuses.fetch({remove: true}),this.balanceModel.fetch())
                .done(this._countBonuses.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        _countBonuses: function() {
            const model = this.bonuses.toJSON();
            const balanceModel = this.balanceModel.toJSON();
            const bonuses = model[0].bonuses;
            const bonusTemplate = model[0].bonusTemplates;
            let count = 0;
            const ACCEPTED = 2;
            const ACTIVE = 3;
            const bigCount = checkCounterClass.prototype.bigCount;
            const preWagerTemplates = bonusTemplate?.filter(el => el.playType === 'prewager');
            const freeSpinsBalance = balanceModel?.balances?.filter(({ balance }) => balance.amount > 0 && balance.currencyCode === 'XXX');

            bonuses?.forEach(function(bonus) {
                if (bonus.status === ACTIVE || bonus.status === ACCEPTED) {
                    if (bonus.playType === 'goldenchips' ||
                        freeSpinsBalance.filter(el => el.referenceId === bonus.bonusInstanceCode)?.length ||
                        preWagerTemplates.filter(el => el.code === bonus.templateCode)?.length) {
                        count++;
                    }
                }
            });

            config.set('bonusCounter', count);
            core.trigger('notification-bonusCopied:updated');
            const bonusMultiviewCounter = config.get('bonusMultiviewCounter');
            const bonusMultiviewCount = bonusMultiviewCounter ? bonusMultiviewCounter : 0;

            if (this.isMobileHeader) {
                count = count + bonusMultiviewCount;
            }

            const className = checkCounterClass.prototype.countClassName(count);
            this.$el.html(this.tmpl('bonus.counter', {
                count,
                className,
                bigCount
            }));
        },

        _showBonusAfterCanceling: function() {
            let count = config.get('bonusCountAfterCanceling');
            const bigCount = checkCounterClass.prototype.bigCount;
            config.set('bonusCounter', count);
            core.trigger('notification-bonusCopied:updated');
            const bonusMultiviewCounter = config.get('bonusMultiviewCounter');
            const bonusMultiviewCount = bonusMultiviewCounter ? bonusMultiviewCounter : 0;

            if (this.isMobileHeader) {
                count = count + bonusMultiviewCount;
            }

            const className = checkCounterClass.prototype.countClassName(count);

            this.$el.html(this.tmpl('bonus.counter', {
                count,
                bigCount,
                className
            }));
        }
    }, {
        nameOfReplacers: [
            'BONUS_COUNTER'
        ]
    });
});
